/**
 * PhotonUI Portal - Main Application Component
 */
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./auth/AuthProvider";
import { AuthGuard } from "./auth/AuthGuard";
import { AppRoles } from "./auth/authConfig";
import { Layout } from "./components/Layout/Layout";
import { HomePage } from "./pages/HomePage";
import { ToolPage } from "./pages/ToolPage";
import { AdminPage } from "./pages/AdminPage";
import { NotFoundPage } from "./pages/NotFoundPage";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          {/* Home */}
          <Route path="/" element={<HomePage />} />

          {/* Tool routes */}
          <Route path="/tool/:toolId" element={<ToolPage />} />

          {/* Admin routes - protected by Portal.Admin role */}
          <Route
            path="/admin/*"
            element={
              <AuthGuard requiredRoles={[AppRoles.PORTAL_ADMIN]}>
                <AdminPage />
              </AuthGuard>
            }
          />

          {/* Catch-all */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
};

export default App;
